import { render, staticRenderFns } from "./ResultadosEncuestas.vue?vue&type=template&id=67c43ec0&scoped=true"
import script from "./ResultadosEncuestas.vue?vue&type=script&lang=js"
export * from "./ResultadosEncuestas.vue?vue&type=script&lang=js"
import style0 from "./ResultadosEncuestas.vue?vue&type=style&index=0&id=67c43ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c43ec0",
  null
  
)

export default component.exports